import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { LOGIN_USER, LOGOUT_USER } from "./constants";
import { DropDownAlert } from "../../components";

import { loginUserSuccess, loginUserFailed } from "./actions";
import ApiRequest from "../../helpers/api_server";

function* login({ payload: { history, reqBody } }) {
    try {
        const { data, info } = yield call(ApiRequest.post, "/user/main/login/lender", reqBody);
        const { status, err_message } = info;
        if (status !== "OK") {
            yield put(loginUserFailed(err_message));
            yield call(() => {
                DropDownAlert.show("danger", err_message);
            });
        } else {
            yield put(loginUserSuccess(data));
            yield call(() => {
                history.replace("/");
                history.go(0);
            });
        }
    } catch (error) {
        console.log("[login]: ", error);
        yield put(loginUserFailed("Mohon periksa jaringan anda!"));
    }
}

/**
 * Logout the user
 * @param {*} param0
 */
function* logout({ payload: { history } }) {
    try {
        yield call(() => {
            history.push("/account/login");
        });
    } catch (error) {}
}

export function* watchLoginUser() {
    yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

function* authSaga() {
    yield all([fork(watchLoginUser), fork(watchLogoutUser)]);
}

export default authSaga;
